<template>
  <div id="detailDiv" class="content-detail">
    <Tabs type="card" @on-click="changeTab" v-model="tabName">
        <TabPane label="汇总描述" icon="ios-apps" name="hzms">
          <div v-show="tabName === 'hzms'">
            <Row :gutter="20" shadow>
              <i-col :md="12">
                <Divider orientation="left">公司收入明细</Divider>
                <Row :gutter="20" shadow style="padding-left: 40px;padding-top: 20px">
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;">
                    <h3>对公收入
                      <InfoPopTip content="统计口径:所有收入中公司转入账户的收入金额,合计/账单月份"/>
                    </h3>
                    <h2>¥{{ homeStat.incoming.corporateIncome.monthAvg }}元</h2>
                    <span>笔均:¥{{ homeStat.incoming.corporateIncome.billAvg }}元</span>
                  </i-col>
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;">
                    <h3>对私收入
                      <InfoPopTip content="统计口径:所有收入中个人转入账户的收入金额,合计/账单月份"/>
                    </h3>
                    <h2>¥{{ homeStat.incoming.privateIncome.monthAvg }}元</h2>
                    <span>笔均:¥{{ homeStat.incoming.privateIncome.billAvg }}元</span>
                  </i-col>
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;">
                    <h3>贷款收入
                      <InfoPopTip content="统计口径:所有收入中贷款收入的金额"/>
                    </h3>
                    <h2>¥{{ homeStat.incoming.loanIncome.monthAvg }}元</h2>
                    <span>累计月份:{{ homeStat.incoming.loanIncome.countData }}</span>
                  </i-col>
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;">
                    <h3>其他收入
                      <InfoPopTip content="剔除对公收入/对私收入/贷款收入的其他收入"/>
                    </h3>
                    <h2>¥{{ homeStat.incoming.otherIncome.monthAvg}}元</h2>
                  </i-col>
                </Row>
                <Divider orientation="left">公司支出明细</Divider>
                <Row :gutter="20" shadow style="padding-left: 40px;padding-top: 20px">
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;">
                    <h3>对公付款
                      <InfoPopTip content="统计口径:所有支出中转给公司账户的支出，合计/账单月份"/>
                    </h3>
                    <h2>￥{{ homeStat.payout.corporatePayout.monthAvg }}元</h2>
                    <span>笔均:¥{{ homeStat.payout.corporatePayout.billAvg }}元</span>
                  </i-col>
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;">
                    <h3>对私付款
                      <InfoPopTip content="统计口径:所有支出中转给个人账户的支出，合计/账单月份"/>
                    </h3>
                    <h2>￥{{ homeStat.payout.privatePayout.monthAvg }}元</h2>
                    <span>笔均:¥{{ homeStat.payout.privatePayout.billAvg }}元</span>
                  </i-col>
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;">
                    <h3>工资支出
                      <InfoPopTip content="统计口径:所有支出中的工资支出"/>
                    </h3>
                    <h2>￥{{ homeStat.payout.wagesPayout.monthAvg }}元</h2>
                    <span>累计月份:{{ homeStat.payout.wagesPayout.countData }}</span>
                  </i-col>
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;">
                    <h3>还贷支出
                      <InfoPopTip content="统计口径:所有支出中的贷款还款支出"/>
                    </h3>
                    <h2>￥{{ homeStat.payout.repayloanPayout.monthAvg }}元</h2>
                    <span>累计月份:{{ homeStat.payout.repayloanPayout.countData }}</span>
                  </i-col>
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;">
                    <h3>缴税支出
                      <InfoPopTip content="统计口径:所有支出中的缴纳税款的支出"/>
                    </h3>
                    <h2>￥{{ homeStat.payout.payTaxes.monthAvg }}元</h2>
                    <span>累计月份:{{ homeStat.payout.payTaxes.countData }}</span>
                  </i-col>
                </Row>
                <Divider orientation="left">关联人交易</Divider>
                <Row :gutter="20" shadow style="padding-left: 40px;padding-top: 20px">
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;" >
                    <h3>法人流入
                      <InfoPopTip content="统计口径:公司法定代表人转入金额,合计/账单月份"/>
                    </h3>
                    <h2>¥{{ homeStat.incoming.legalFlowIn.monthAvg }}元</h2>
                    <span>次数:{{ homeStat.incoming.legalFlowIn.countData }}</span>&nbsp;
                    <span>笔均:{{ homeStat.incoming.legalFlowIn.billAvg }}</span>
                  </i-col>
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;" >
                    <h3>法人流出
                      <InfoPopTip content="统计口径:公司法定代表人转出金额,合计/账单月份"/>
                    </h3>
                    <h2>¥{{ homeStat.payout.legalFlowOut.monthAvg }}元</h2>
                    <span>次数:{{ homeStat.payout.legalFlowOut.countData }}</span>&nbsp;
                    <span>笔均:{{ homeStat.payout.legalFlowOut.billAvg }}</span>
                  </i-col>
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;" >
                    <h3>关联人流入
                      <InfoPopTip content="统计口径:公司主要人员转入金额，不含法人,合计/账单月份"/>
                    </h3>
                    <h2>¥{{ homeStat.associated.associatedFlowInAmount }}元</h2>
                    <span>次数:{{ homeStat.associated.associatedFlowInCount }}</span>&nbsp;
                    <span>人数:{{ homeStat.associated.associatedPeopleCount}}</span>
                  </i-col>
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;" >
                    <h3>关联人流出
                      <InfoPopTip content="统计口径:公司主要人员转出金额，不含法人,合计/账单月份"/>
                    </h3>
                    <h2>¥{{ homeStat.associated.associatedFlowOutAmount }}元</h2>
                    <span>次数:{{ homeStat.associated.associatedFlowOutCount }}</span>&nbsp;
                    <span>人数:{{ homeStat.associated.associatedPeopleCount }}</span>
                  </i-col>
                </Row>
                <Row :gutter="20" shadow style="padding-left: 40px;padding-top: 20px">
                  <WordCloudMap style="height: 300px;width: 100%;" :value="stat.wordCloudData" ref="wordcloudmap"/>
                </Row>
              </i-col>
              <i-col :md="12" style="align-content: center">
                <Card shadow>
                  <SmoothLine style="height: 380px;" :value="stat.incomingList" text="收入月度走势" ref="incomingListLine"/>
                </Card>
                <Card shadow>
                  <SmoothLine style="height: 380px;" :value="stat.payoutList" text="支出月度走势" ref="payoutListLine"/>
                </Card>
                <Card shadow>
                  <chart-bar style="height: 380px;" :x="barData.x" :y="barData.y" text="24小时交易分布" ref="charbar"/>
                </Card>
              </i-col>
            </Row>
            <Row>
              <Col span="6">
                <chart-pie style="height: 250px;" :value="stat.tradePieData" text="交易占比" ref="tradePie"></chart-pie>
              </Col>
              <Col span="6">
                <chart-pie style="height: 250px;" :value="stat.payoutPieData" text="支出类型占比" ref="payoutPie"></chart-pie>
              </Col>
              <Col span="6">
                <chart-pie style="height: 250px;" :value="stat.incomingPieData" text="收入类型占比" ref="incomingPie"></chart-pie>
              </Col>
              <Col span="6">
                <chart-pie style="height: 250px;" :value="stat.consumeSubTypePieData" text="消费子类占比"
                          ref="consumeSubTypePie"></chart-pie>
              </Col>
            </Row>
            <Card shadow v-if="dataMap.bank_balance_list.length > 0">
              <SmoothLine style="height: 300px;" :value="stat.balanceList" text="银行卡余额走势图" ref="balanceListLine"/>
            </Card>
            <Card shadow v-if="dataMap.monthlySummaryList.length > 0">
              <ChartTableBar style="height: 300px;" :value="dataMap.monthlySummaryList" text="月度交易数据"
                            :series="monthlySummaryBar" ref="monthlySummaryBar"/>
            </Card>
          </div>
        </TabPane>
      <TabPane label="上下游分析" icon="md-swap" name="sxyfx">
        <div v-show="tabName === 'sxyfx'">
          <Divider orientation="left">公司上游</Divider>
          <Table border highlight-row :columns="updownStreamAnalysisColumns" :data="dataMap.upstream_company"></Table>
          <Divider orientation="left">公司下游</Divider>
          <Table border highlight-row :columns="updownStreamAnalysisColumns" :data="dataMap.downstream_company"></Table>
          <Divider orientation="left">个人上游</Divider>
          <Table border highlight-row :columns="updownStreamAnalysisColumns" :data="dataMap.upstream_person"></Table>
          <Divider orientation="left">个人下游</Divider>
          <Table border highlight-row :columns="updownStreamAnalysisColumns" :data="dataMap.downstream_person"></Table>
        </div>
      </TabPane>
      <TabPane label="分渠道收支汇总" icon="ios-clipboard" name="fqdszhz">
        <div v-show="tabName === 'fqdszhz'">
          <Divider orientation="left" v-if="dataMap.bill_stat_weixin">微信汇总数据</Divider>
          <Table border highlight-row :columns="statBaseColumns" :data="dataMap.bill_stat_weixin" v-if="dataMap.bill_stat_weixin"></Table>
          <Divider orientation="left" v-if="dataMap.bill_stat_zhifubao">支付宝汇总数据</Divider>
          <Table border highlight-row :columns="statBaseColumns" :data="dataMap.bill_stat_zhifubao" v-if="dataMap.bill_stat_zhifubao"></Table>
          <Divider orientation="left" v-if="dataMap.bill_stat_bank">银行汇总数据</Divider>
          <Table border highlight-row :columns="statBaseColumns" :data="dataMap.bill_stat_bank" v-if="dataMap.bill_stat_bank"></Table>
          <Divider orientation="left">月度交易数据</Divider>
          <Table border highlight-row :columns="monthlySummaryColumns" :data="dataMap.monthlySummaryList"></Table>
          <Divider orientation="left">小额交易汇总数据（五千以下）</Divider>
          <Table border highlight-row :columns="statBaseColumns" :data="dataMap.hz_sj_wq_yx"></Table>
        </div>
      </TabPane>
      <TabPane label="支出消费数据汇总" icon="md-swap" name="zzyxfsjhz">
        <div v-show="tabName === 'zzyxfsjhz'">
          <Divider orientation="left">自我转账交易<InfoPopTip content="法人支出详情，统计5条"/></Divider>
          <Table border highlight-row :columns="transferBaseColumns" :data="dataMap.self_transfer_summary"></Table>
          <Divider orientation="left">主要支出对手交易<InfoPopTip content="主要支出对手详情（按照金额排序），统计5条"/></Divider>
          <Table border highlight-row :columns="payBaseColumns" :data="dataMap.pay_counterparty_count_summary"></Table>
          <Divider orientation="left">主要支出交易次数对手<InfoPopTip content="主要支出交易次数对手详情（按照交易次数排序），统计5条"/></Divider>
          <Table border highlight-row :columns="payBaseColumns" :data="dataMap.transfer_counterparty_count_summary"></Table>
          <Divider orientation="left">支出类型交易详情<InfoPopTip content="主要支出类型交易详情"/></Divider>
          <Table border highlight-row :columns="payBaseColumns" :data="dataMap.payout_type_list"></Table>
          <Divider orientation="left">主要大额消费详情</Divider>
          <Table border highlight-row :columns="payDetailColumns" :data="dataMap.pay_counterparty_max_detail"></Table>
        </div>
      </TabPane>
        <TabPane label="资产与收入" icon="logo-yen" name="zcysr">
          <div v-show="tabName === 'zcysr'">
<!--            <Divider orientation="left">金额汇总数据<span v-if="dataMap.invalid_money">(剔除交易总金额：{{ Number(dataMap.invalid_money).toFixed(0) }})</span></Divider>
            <Table border highlight-row :columns="statBaseColumns" :data="dataMap.hz_sj"></Table>-->
<!--            <Divider orientation="left" >日均余额数据</Divider>
            <Table border highlight-row :columns="dailyAvgColumns" :data="dataMap.bank_daily_avg_balance"></Table>-->
            <Divider orientation="left">自我转账交易<InfoPopTip content="法人收入详情，至多5条"/></Divider>
            <Table border highlight-row :columns="transferBaseColumns" :data="dataMap.self_transfer_summary"></Table>
            <Divider orientation="left">主要收入对手交易<InfoPopTip content="主要收入对手详情（按照金额排序），统计5条"/></Divider>
            <Table border highlight-row :columns="payBaseColumns" :data="dataMap.main_income_counterparty"></Table>
            <Divider orientation="left">主要收入交易次数对手<InfoPopTip content="主要收入交易次数对手详情（按照交易次数排序），统计5条"/></Divider>
            <Table border highlight-row :columns="payBaseColumns" :data="dataMap.main_income_counterparty_count"></Table>
            <Divider orientation="left">收入类型交易详情<InfoPopTip content="主要支出类型交易详情"/></Divider>
            <Table border highlight-row :columns="payBaseColumns" :data="dataMap.incoming_type_list"></Table>
            <Divider orientation="left" v-if="dataMap.manage_money_trade_summer">理财数据</Divider>
            <Table border highlight-row :columns="manageMoneyColumns" :data="dataMap.manage_money_trade_summer"></Table>
          </div>
        </TabPane>
        <TabPane label="消费信贷汇总" icon="ios-card" name="xfxdhz">
          <div v-show="tabName === 'xfxdhz'">
            <Divider orientation="left" v-if="dataMap.credit_card_summary">卡交易数据</Divider>
            <Table border highlight-row :columns="cardBaseColumns" :data="dataMap.credit_card_summary"></Table>
            <Divider orientation="left" v-if="dataMap.repayloan_summary">还款数据</Divider>
            <Table border highlight-row :columns="cardBaseColumns" :data="dataMap.repayloan_summary"></Table>
          </div>
        </TabPane>
        <TabPane label="生活类交易数据汇总" icon="ios-basket" name="shljysjhz">
          <div v-show="tabName === 'shljysjhz'">
            <Divider orientation="left" v-if="dataMap.sdm_monthly_summary">水电煤支出</Divider>
            <Table border highlight-row :columns="lifeColumns" :data="dataMap.sdm_monthly_summary"></Table>
            <Divider orientation="left" v-if="dataMap.car_monthly_summary">汽车相关支出（包括：加油、停车）</Divider>
            <Table border highlight-row :columns="lifeColumns" :data="dataMap.car_monthly_summary"></Table>
            <Divider orientation="left" v-if="dataMap.travel_monthly_summary">出行旅游相关支出（包括：火车、飞机、酒店）</Divider>
            <Table border highlight-row :columns="lifeColumns" :data="dataMap.travel_monthly_summary"></Table>
          </div>
        </TabPane>
    </Tabs>

  </div>
</template>
<script>
import ContentDataReport from './content-data-report.vue'
import { ChartBar, ChartPie, ChartTableBar, ProgressRing, SmoothLine, WordCloudMap } from '_c/charts'
import { InfoPopTip, InforCard } from '_c/info-card'
import CountTo from '_c/count-to'

export default {
  name: 'content-detail',
  props: {
    dataMap: {
      type: Object
    },
    score: Object,
    barData: Object,
    stat: Object,
    homeStat: Object
  },
  components: {
    ContentDataReport,
    ChartTableBar,
    ProgressRing,
    InforCard,
    ChartBar,
    CountTo,
    WordCloudMap,
    InfoPopTip,
    SmoothLine,
    ChartPie
  },
  data () {
    return {
      tabName: 'hzms',
      colSpan: 12,
      monthlySummaryBar: {
        x: 'statDesc',
        y: [{
          name: '收入',
          key: 'income'
        }, {
          name: '支出',
          key: 'payout'
        }, {
          name: '其他',
          key: 'other'
        }]
      },
      updownStreamAnalysisColumns: [{
        key: 'businessType',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-person'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易对手')
          ])
        }
      }, {
        key: 'yearAvg',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'md-contact'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易对手身份')
          ])
        }
      }, {
        key: 'money',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-cash'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易金额')
          ])
        }
      }, {
        key: 'countData',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-podium'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易次数')
          ])
        }
      }],
      payDetailColumns: [
        {
          key: 'flowTime',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-information-circle'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易时间')
            ])
          }
        },
        {
          key: 'counterparty',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-person'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易对手')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'logo-yen'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '金额')
            ])
          }
        },
        {
          key: 'flowCard',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'logo-usd'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '付款方式')
            ])
          }
        }
      ],
      payBaseColumns:
        [{
          key: 'businessType',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-people'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易对手')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-cash'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易金额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-podium'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易次数')
            ])
          }
        }, {
          key: 'rankData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-podium'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '排名')
            ])
          }
        }],

      statBaseColumns:
        [{
          key: 'businessType',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-paper'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '账单交易类型')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'logo-yen'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '金额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-podium'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '笔数')
            ])
          }
        }, {
        //   key: 'yearAvg',
        //   className: 'table-header-cell',
        //   renderHeader: (h, params) => {
        //     return h('div', [
        //       h('Icon', {
        //         props: {
        //           type: 'md-analytics'
        //         },
        //         style: {
        //           marginRight: '5px'
        //         }
        //       }),
        //       h('strong', '年均')
        //     ])
        //   }
        // }, {
          key: 'monthAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-analytics'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '月均')
            ])
          }
        }, {
          key: 'rankData',
          className: 'table-header-cell',
          render: (h, params) => {
            return h('div', [
              h('strong', '前' + params.row.rankData + '%')
            ])
          },
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-stats'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '排名')
            ])
          }
        }],
      monthlySummaryColumns:
        [{
          key: 'statDesc',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-calendar'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '月份')
            ])
          }
        }, {
          key: 'income',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-trending-up'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '收入')
            ])
          }
        }, {
          key: 'payout',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-trending-down'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '支出')
            ])
          }
        }, {
          key: 'other',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('tooltip', {
              props: {
                transfer: true,
                placement: 'top',
                'max-width': '240'
              }
            },
            [
              h('span', [
                h('Icon', {
                  props: {
                    type: 'ios-cash-outline'
                  },
                  style: {
                    marginRight: '5px'
                  }
                }),
                h('span', '其他'),
                h('Icon', {
                  props: {
                    type: 'md-help-circle',
                    color: '#c8c8c8'
                  }
                })
              ]),
              h('div',
                { slot: 'content' },
                [h('p', '剔除转账/工资/收单的其他收入')]
              )
            ])
          }
        }, {
          key: 'notRecording',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('tooltip', {
              props: {
                transfer: true,
                placement: 'top',
                'max-width': '240'
              }
            },
            [
              h('span', [
                h('Icon', {
                  props: {
                    type: 'ios-cash-outline'
                  },
                  style: {
                    marginRight: '5px'
                  }
                }),
                h('span', '不计收入'),
                h('Icon', {
                  props: {
                    type: 'md-help-circle',
                    color: '#c8c8c8'
                  }
                })
              ]),
              h('div',
                { slot: 'content' },
                [h('p', '包含：活期转定期和定期转活期')]
              )
            ])
          }
        }],
      cardBaseColumns:
        [{
          key: 'cardNo',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-card'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '银行/账户')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'logo-yen'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '金额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-podium'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '笔数')
            ])
          }
        }, {
        //   key: 'yearAvg',
        //   className: 'table-header-cell',
        //   renderHeader: (h, params) => {
        //     return h('div', [
        //       h('Icon', {
        //         props: {
        //           type: 'md-analytics'
        //         },
        //         style: {
        //           marginRight: '5px'
        //         }
        //       }),
        //       h('strong', '年均')
        //     ])
        //   }
        // }, {
          key: 'monthAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-analytics'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '月均')
            ])
          }
        }, {
          key: 'rankData',
          className: 'table-header-cell',
          render: (h, params) => {
            return h('div', [
              h('strong', '前' + params.row.rankData + '%')
            ])
          },
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-stats'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '排名')
            ])
          }
        }],
      dailyAvgColumns:
        [{
          key: 'cardNo',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-card'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '银行卡')
            ])
          }
        // }, {
        //   key: 'startTime',
        //   className: 'table-header-cell',
        //   renderHeader: (h, params) => {
        //     return h('div', [
        //       h('Icon', {
        //         props: {
        //           type: 'md-calendar'
        //         },
        //         style: {
        //           marginRight: '5px'
        //         }
        //       }),
        //       h('strong', '统计开始日期')
        //     ])
        //   }
        // }, {
        //   key: 'endTime',
        //   className: 'table-header-cell',
        //   renderHeader: (h, params) => {
        //     return h('div', [
        //       h('Icon', {
        //         props: {
        //           type: 'md-calendar'
        //         },
        //         style: {
        //           marginRight: '5px'
        //         }
        //       }),
        //       h('strong', '统计结束日期')
        //     ])
        //   }
        }, {
          key: 'dayAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-analytics'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '日均')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell',
          render: (h, params) => {
            return h('div', [
              h('strong', '近' + params.row.countData + '天')
            ])
          },
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-calendar'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '活跃天数')
            ])
          }
        }, {
          title: '排名',
          key: 'rankData',
          className: 'table-header-cell',
          render: (h, params) => {
            return h('div', [
              h('strong', '前' + params.row.rankData + '%')
            ])
          },
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-stats'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '排名')
            ])
          }
        }],
      yuebaoColumns:
        [{
          key: 'businessType',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-paper'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易类型')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'logo-yen'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '日均金额')
            ])
          }
        }, {
          key: 'dayAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-clipboard'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '日均生息')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-calendar'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '持有天数')
            ])
          }
        }, {
          key: 'rankData',
          className: 'table-header-cell',
          render: (h, params) => {
            return h('div', [
              h('strong', '前' + params.row.rankData + '%')
            ])
          },
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-stats'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '排名')
            ])
          }
        }],
      manageMoneyColumns:
        [{
          key: 'businessType',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-paper'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '理财类型')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-cash'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易总额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-podium'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易次数')
            ])
          }
        }, {
          key: 'yearAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-arrow-round-back'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '买入金额')
            ])
          }
        }, {
          key: 'monthAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-arrow-round-forward'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '卖出金额')
            ])
          }
        }],
      lifeColumns:
        [{
          key: 'statTime',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-calendar'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易月份')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-cash'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易总额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-podium'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易次数')
            ])
          }
        }, {
          key: 'rankData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-stats'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '排名')
            ])
          }
        }],
      onlineShoppingColumns:
        [{
          key: 'businessType',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'logo-apple'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '品牌')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-cash'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易总额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-podium'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易次数')
            ])
          }
        }, {
          key: 'dayAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-basket'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '件均消费')
            ])
          }
        }, {
          title: '月均消费',
          key: 'monthAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-cart'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '月均消费')
            ])
          }
        }, {
          key: 'rankData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-stats'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '排名')
            ])
          }
        }],
      transferBaseColumns:
        [{
          key: 'businessType',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-people'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易对手')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-cash'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易总额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-podium'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易次数')
            ])
          }
        }, {
          key: 'yearAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-trending-up'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '收入')
            ])
          }
        }, {
          key: 'monthAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-trending-down'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '支出')
            ])
          }
        }, {
          key: 'rankData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-stats'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '排名')
            ])
          }
        }],
      wagesInfoColumns:
        [{
          key: 'money',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'logo-yen'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '工资总额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-podium'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '发放次数')
            ])
          }
        }, {
          key: 'monthAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'logo-yen'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '月均工资')
            ])
          }
        }, {
          key: 'yearAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-thumbs-up'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '最高')
            ])
          }
        }, {
          key: 'dayAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-thumbs-up-outline'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '最低')
            ])
          }
        }, {
          title: '排名',
          key: 'rankData',
          className: 'table-header-cell',
          render: (h, params) => {
            return h('div', [
              h('strong', '前' + params.row.rankData + '%')
            ])
          },
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-stats'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '排名')
            ])
          }
        }],
      posTradeInfoColumns:
        [{
          key: 'money',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-cash'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '收单总额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-calendar'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '累计月份')
            ])
          }
        }, {
          key: 'monthAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-undo'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '月均收款')
            ])
          }
        }, {
          key: 'yearAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-thumbs-up'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '最高')
            ])
          }
        }, {
          key: 'dayAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-thumbs-up-outline'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '最低')
            ])
          }
        }, {
          key: 'rankData',
          className: 'table-header-cell',
          render: (h, params) => {
            return h('div', [
              h('strong', '前' + params.row.rankData + '%')
            ])
          },
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-stats'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '排名')
            ])
          }
        }],
      tradeInfoColumns: [{
        key: 'counterparty',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-people'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易对手')
          ])
        }
      }, {
        key: 'flowTime',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-calendar'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易时间')
          ])
        }
      }, {
        key: 'flowType',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-analytics'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易类型')
          ])
        }
      }, {
        key: 'flowDirection',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-thumbs-up'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易方向')
          ])
        }
      }, {
        key: 'money',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-cash'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易金额')
          ])
        }
      }, {
        key: 'balance',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'logo-yen'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '金额')
          ])
        }
      }],
      highFrequencyTradeInfoColumns: [{
        key: 'counterparty',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-people'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易对手')
          ])
        }
      }, {
        key: 'flowTime',
        className: 'table-header-cell',
        render: (h, params) => {
          return h('div', [
            h('span', params.row.flowTime.slice(0, 10))
          ])
        },
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-calendar'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易时间')
          ])
        }
      }, {
        key: 'flowType',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-podium'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易次数')
          ])
        }
      }, {
        key: 'money',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-cash'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易金额')
          ])
        }
      }]
    }
  },
  mounted: function () {
    this.setData(this.$parent.dataMap, this.$parent.homeStat, this.$parent.score, this.$parent.barData, this.$parent.stat)
  },
  methods: {
    setData (dataMap, homeStat, score, barData, stat) {
      this.dataMap = this.getDataMap()
      this.dataMap = dataMap
      this.score = score
      this.barData = barData
      this.stat = stat
      this.homeStat = homeStat
    },
    getDataMap () {
      return {
        uploadLog: [],
        hz_sj: [],
        hz_sj_yw_yx: [],
        hz_sj_wq_yx: [],
        bill_stat_weixin: [],
        bill_stat_zhifubao: [],
        bill_stat_bank: [],
        monthlySummaryList: [],
        credit_card_summary: [],
        repayment_summary: [],
        yueebao_daily_avg_balance: [],
        manage_money_trade_summer: [],
        phone_monthly_summary: [],
        sdm_monthly_summary: [],
        car_monthly_summary: [],
        travel_monthly_summary: [],
        transfer_monthly_summary: [],
        transfer_counterparty_summary: [],
        transfer_counterparty_count_summary: [],
        transfer_counterparty_night_count_summary: [],
        judicial_trade_list: [],
        error_flow_list: [],
        leisure_entertainment_list: [],
        pay_counterparty_count_summary: [],
        pay_counterparty_max_detail: [],
        bank_daily_avg_balance: [],
        wages_info_summer: [],
        pos_trade_summer: [],
        online_shopping_summary: [],
        bank_balance_list: [],
        high_frequency_transfer_list: [],
        night_trade_list: []
      }
    }
  }
}
</script>
<style>
.content-detail {
  margin-top: 53pt;
}
.dvd-font {
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 18pt;
    color: #666666;
}
.ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active {
  background: #1242CD;
  color:white;
}
.ivu-tabs-nav-container{
  font-size: 18px;
  font-weight: bold;
}
.ivu-tabs-tab {
  background: white;
  color:#1242CD;
}
.hz-row {
  text-align:center;
  font-weight: bold;
  color:#1242CD
}
.count-num {
  font-size: 30pt;
}
.count-title {
  font-size:14pt;
  color:#A1A1A1;
}
</style>
